import { components } from "react-select";
export const MultiSelectDropDownOptionsComponent = (props: any) => {
  const { data, selectProps } = props;
  const selectedValues = selectProps.value || [];
  const selectedIds = Array.isArray(selectedValues)
  ? selectedValues.flatMap((selected) =>
      Array.isArray(selected.value)
        ? selected.value.map((v:any) => v.id || v.sapDealerCode) // Ensure IDs match
        : [selected.value?.id || selected.value?.sapDealerCode]
    )
  : [selectedValues.value?.id || selectedValues.value?.sapDealerCode];
  // Check if the current option is in the selected list
  const isChecked = selectedIds.includes(
    data.value.id || data.value.sapDealerCode
  );
  return (
    <components.Option {...props}>
      {props.value === "divider" ? (
        <div style={{ borderTop: "1px solid #E0E0E0", marginBottom: "10px" }} />
      ) : (
        <label className="container">
          <input
            type="checkbox"
            className={`${
              isChecked ? "downloadSampleConsentText" : "body1"
            } checkmarks bg-white`}
            checked={isChecked}
            readOnly
          />
          <span className="checkmark"></span>
          <span
            className={`${
              isChecked ? "downloadSampleConsentText" : "body1"
            }  ml-6`}
          >
            {props.label}
          </span>
        </label>
      )}
    </components.Option>
  );
};
